export const tippy = require( 'tippy.js' ),
  config = {
    placement: 'top',
    arrow: true,
    arrowType: 'round',
    animation: 'shift-toward',
    theme: 'selectra',
    performance: true,
    interactive: true,
    zIndex: 10005
  },
  loadLocalTooltips = ( parentSelector ) => {
    const tooltips = document.querySelector( parentSelector ).querySelectorAll( '[data-toggle="tooltip"]' );
    if ( tooltips.length > 0 ) {
      tippy( tooltips, config );
    }
  };

export default function loadTooltips() {
  loadLocalTooltips( 'body' );
}
